import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { ForeignExchanges, ForeignExchangeFilters } from '../../models/ForeignExchange';

const useForeingExchangeService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetForeignExchanges, setfetchingGetForeignExchange] = useState(false);
    const [fetchingCreateForeignExchanges, setfetchingCreateForeignExchange] = useState(false);
    const [fetchingStoreForeignExchanges, setfetchingStoreForeignExchange] = useState(false);
    const [fetchingEditForeignExchange, setfetchingEditForeignExchange] = useState(false);
    const [fetchingUpdateForeignExchange, setfetchingUpdateForeignExchange] = useState(false);
    const [fetchingDeleteForeignExchange, setfetchingDeleteForeignExchange] = useState(false);


    const getForeignExchange = (currencyFilters: ForeignExchangeFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(currencyFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.FOREIGN_EXCHANGE.GET_FOREIGN_EXCHANGE}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setfetchingGetForeignExchange
        });

    };


    const createForeignExchange = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.CREATE_FOREIGN_EXCHANGE,
            setFetching: setfetchingCreateForeignExchange
        });
    };

    const storeForeignExchange = (foreignExchanges: ForeignExchanges, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.STORE_FOREIGN_EXCHANGE,
            body: foreignExchanges,
            setFetching: setfetchingStoreForeignExchange
        });
    };

    const storeManuallyForeignExchange = (foreignExchanges: ForeignExchanges, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.STORE_MANUALLY_FOREIGN_EXCHANGE,
            body: foreignExchanges,
            setFetching: setfetchingStoreForeignExchange
        });
    };

    const editForeignExchange = (foreignExchangeId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.EDIT_FOREIGN_EXCHANGE.replace(':id', foreignExchangeId.toString()),
            setFetching: setfetchingEditForeignExchange
        });
    };

    const updateForeignExchange = (foreignExchangeId: number, foreignExchange: ForeignExchanges, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.UPDATE_FOREIGN_EXCHANGE.replace(':id', foreignExchangeId.toString()),
            body: foreignExchange,
            setFetching: setfetchingUpdateForeignExchange
        });
    };

    const deleteForeignExchange = (foreignExchangeId: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.FOREIGN_EXCHANGE.DELETE_FOREIGN_EXCHANGE.replace(':id', foreignExchangeId.toString()),
            setFetching: setfetchingDeleteForeignExchange
        });
    };

    return {
        fetchingGetForeignExchanges,
        fetchingCreateForeignExchanges,
        fetchingStoreForeignExchanges,
        fetchingEditForeignExchange,
        fetchingUpdateForeignExchange,
        fetchingDeleteForeignExchange,
        getForeignExchange,
        createForeignExchange,
        storeForeignExchange,
        storeManuallyForeignExchange,
        editForeignExchange,
        updateForeignExchange,
        deleteForeignExchange
    };

}

export default useForeingExchangeService;
